export const EXPOSE_ALL_WORKFLOWS_TO_MCP_MODAL_KEY = 'exposeAllWorkflowsToMcpModal';
